import envConfig from '@hulu/env-config';

export const amplifyConfig = {
  Auth: {
    region: envConfig.REACT_APP_COGNITO_REGION,
    userPoolId: envConfig.REACT_APP_COGNITO_USER_POOL_ID,
    userPoolWebClientId: envConfig.REACT_APP_COGNITO_MARKETER_CLIENT_ID,
  },
};
